// Todos.js

import React from 'react';
import {TodoItem} from './TodoItem';

export const Todos = (props) => {
    let myStyle={
        minHeight: "70vh",
        margin: "40px auto"
    }
    return (
        <div className="container" style={myStyle}>
            <h3 className="my-3">Notes List</h3>
            {/* <TodoItem todo={props.todos[0]}/> */}
            {/* {props.todos.map((todo)=>{
                return <TodoItem todo={props.todos[0]}/> 
            })} */}
            {props.todos.length===0? "No Todos to display": 
            /* CANT UNDERSTAND BELOW */
                props.todos.map((todo)=>{
                    // return (
                    //     <>
                    //         <TodoItem todo={todo} key={todo.sno} onDelete={props.onDelete}/> 
                    //         <hr/>
                    //     </>
                    // )
                    return (<TodoItem todo={todo} key={todo.sno} onDelete={props.onDelete}/> )
                })
            }
        </div>
    )
}